<template>
  <div ref="imageBox" @mousedown="onmousedownHandle" style="position:relative;width:100%;height:100%;overflow:hidden;">
    <!--图片-->
    <div v-if="!isFullScreen" style="width: 100%;height: 100%;">
      <img ref="imageSource"
           height="60%"
           :src="pictureUrl"
           style="position: absolute;"
           :style="{transform:'rotateZ('+deg+'deg) scale('+multiples+') translateX(-50%)',transformOrigin:'0 center',top:top+'px',left:left+'px',}">
    </div>
    <div v-if="isFullScreen" style="width: 100%;height: 100%">
      <v-img height="100%"
             width="100%"
             contain
             :eager="true"
             :src="pictureUrl"></v-img>
    </div>
    <!--图片工具栏-->
    <div style="position: absolute;bottom: 60px;left: 50%;transform: translateX(-50%);background-color: white;width: 270px;height: 50px;border-radius: 10px;z-index: 1000;
    box-shadow:0 0 4px rgba(42,130,228,0.5);">
      <div style="display: flex;justify-content: space-around;width: 100%;padding-left: 10px;padding-right: 10px">
        <!-- 旋转90度 -->
        <button @click="rotate">
          <p style="font-size:22px;color:#C4C4C4;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe64e;</p>
        </button>
        <!-- 全屏查看 -->
        <button @click="fullScreen">
          <p style="font-size:18px;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily"
             :style="{'color':isFullScreen?'rgba(42, 130, 228, 1)':'#C4C4C4'}">&#xe624;</p>
        </button>
        <!-- 拖拽 -->
        <button @click="drag">
          <p style="font-size:23px;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily" :style="{'color':draggable?'rgba(42, 130, 228, 1)':'#C4C4C4'}">&#xe672;</p>
        </button>
        <!-- 放大0.2 -->
        <button @click="magnify">
          <p style="font-size:20px;color:#C4C4C4;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe642;</p>
        </button>
        <!-- 缩小0.2 -->
        <button @click="shrink">
          <p style="font-size:20px;color:#C4C4C4;cursor:pointer;line-height: 50px;text-align: center" class="iconfontFamily">&#xe63b;</p>
        </button>
        <!-- 比例 -->
        <p style="font-size:16px;color:#C4C4C4;cursor:pointer;line-height: 50px;text-align: center;width: 50px" >{{Number(multiples*100).toFixed()}}%</p>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "OnePicturePreviewer",
  props:["pictureUrl"],
  data(){
    return{

      isFullScreen:false,

      top:0,
      left:0,
      showPreviewDialog:false,
      deg:0,
      fullScreenMode:"vertical",
      fullScreenRatio:1,
      draggable:false,
      multiples:1,

    }

  },
  methods:{
    // 放大
    magnify(){
      if(this.multiples >= 3 || this.isFullScreen){
        return
      }
      this.multiples += 0.2
    },
    // 缩小
    shrink(){
      if(this.multiples <= 0.3 || this.isFullScreen){
        return
      }
      this.multiples -= 0.2
    },
    fullScreen(){
      let verticalRatio = 1/0.6
      let horizontalRatio = this.$refs.imageBox.offsetWidth/this.$refs.imageSource.width
      if(verticalRatio > horizontalRatio){
        this.fullScreenRatio = horizontalRatio
      }else{
        this.fullScreenRatio = verticalRatio
      }
      this.top = this.$refs.imageBox.clientHeight*0.2
      this.left = this.$refs.imageBox.clientWidth*0.5
      this.deg = 0
      this.multiples = this.fullScreenRatio
    },
    // 旋转
    rotate(){
      if(this.isFullScreen){
        return
      }
      this.deg += 90;
      if(this.deg >= 360){
        this.deg = 0
      }
    },
    drag(){
      console.log("点击小手")
      this.draggable = !this.draggable
      this.isFullScreen = false
    },
    onmousedownHandle(e) {
      console.log(this.draggable)
      if(!this.draggable){
        return
      }
      const that = this;
      this.$refs.imageBox.onmousemove = function (el) {
        const ev = el || window.event; // 阻止默认事件
        ev.preventDefault();
        that.left += ev.movementX;
        that.top += ev.movementY;
      };
      this.$refs.imageBox.onmouseup = function () {
        // 鼠标抬起时将操作区域的鼠标按下和抬起事件置为null 并初始化
        that.$refs.imageBox.onmousemove = null;
        that.$refs.imageBox.onmouseup = null;
      };
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        return false;
      }
    },
    wheelHandle(e) {
      // 兼容性处理 => 火狐浏览器判断滚轮的方向是属性 detail，谷歌和ie浏览器判断滚轮滚动的方向是属性 wheelDelta
      const ev = e || window.event;
      // dir = -dir; // dir > 0 => 表示的滚轮是向上滚动，否则是向下滚动 => 范围 (-120 ~ 120)
      const dir = ev.detail ? ev.detail * -120 : ev.wheelDelta;
      //滚动的数值 / 2000 => 表示滚动的比例，用此比例作为图片缩放的比例
      this.imgScaleHandle(dir / 6000);
    },
    imgScaleHandle(zoom) {
      /**
       * 图片的缩放
       * zoom >0 放大
       * zoom <0 缩小
       */
      // 缩放范围
      if(zoom > 0){
        if(this.multiples + 0.1 <= 3.05){
          let decimalPart = (this.multiples.toFixed(2)*10 - parseInt(this.multiples.toFixed(2)*10));
          this.multiples += 0.1 - decimalPart/10;
        }
      }else{
        if(this.multiples - 0.1 > 0.195 ){
          let decimalPart = (this.multiples.toFixed(2)*10 - parseInt(this.multiples.toFixed(2)*10));
          if(decimalPart === 0){
            this.multiples += -0.1
          }else{
            this.multiples += - decimalPart/10
          }
        }
      }
    },

  },
  mounted(){
    this.top = this.$refs.imageBox.clientHeight*0.2
    this.left = this.$refs.imageBox.clientWidth*0.5
    // 兼容火狐浏览器
    this.mouseWheelEvt = /Firefox/i.test(navigator.userAgent)? "DOMMouseScroll" : "mousewheel";
    // 为空间区域绑定鼠标滚轮事件 =》 处理函数是wheelHandle
    // 如果你监听了window的scroll或者touchmove事件，你应该把passive设置为true，这样滚动就会流畅很多
    this.$refs.imageBox.addEventListener(this.mouseWheelEvt, this.wheelHandle, {passive:true});
  },
  destroyed() {
    //取消监听
    // this.$refs.imageBox.removeEventListener(this.mouseWheelEvt,this.wheelHandle,{passive:true});
  }


}
</script>

<style scoped>

</style>